<div class="d-flex align-items-center flex-column shopping-cart-preview-container">

  @if (isAuthenticated == false) {
    <ng-container [ngTemplateOutlet]="guest"></ng-container>
  }
  @if (isAuthenticated == true) {
    @if (cart == undefined) {
      <ng-container [ngTemplateOutlet]="user_cartundefined"></ng-container>
    }
    @if (cart != undefined && cartItemCount <= 0) {
      <ng-container [ngTemplateOutlet]="user_cartempty">
      </ng-container>
    }
    @if (cart != undefined && cartItemCount > 0) {
      <ng-container [ngTemplateOutlet]="user_cartfull"></ng-container>
    }
  }

</div>

<ng-template #customerinfo>
  <div class="w-100">
    <span class="ms-2" i18n="@@CartPreviewCustomerNumberInfoPrefix">Customer</span>
    <span class="fw-bold"> {{customerNumber}} </span>
    <div class="ms-2">{{ customerName }}</div>
    <span i18n="@@CartPreviewCustomerNumberInfoSuffix">&nbsp;</span>
  </div>
</ng-template>

<ng-template #guest>
  <div class="h-100 w-100 d-flex flex-column align-items-center justify-content-center">
    <i class="bi bi-lock"></i>
    <h4 i18n="@@CartPreviewGuestHeadline">Login to order</h4>
    <div class="text-center" i18n="@@CartPreviewGuestMessage">To start shopping, create a cart, add items and
      ...</div>
    <div class="btn btn-primary btn-pretty mt-3" i18n="@@CartPreviewGuestLoginButton" [routerLink]="['/login']">Login
    </div>
    <a class="mt-3" i18n="@@CartPreviewGuestRegisterLink" [routerLink]="['/register']">Not yet registered?</a>
  </div>
</ng-template>

<ng-template #user_cartundefined>
  <ng-container [ngTemplateOutlet]="customerinfo"></ng-container>
  <div class="h-100 w-100 d-flex flex-column align-items-center justify-content-center">
    <i class="bi bi-cart4"></i>
    <h4 i18n="@@CartPreviewMissingCartHeadline">Create a cart</h4>
    <div class="text-center" i18n="@@CartPreviewMissingCartMessage">To start shopping, you must create a
      cart</div>
    <div class="btn btn-primary btn-pretty mt-3" i18n="@@CartPreviewMissingCartCreateCartButton"
    (click)="cartCreationDialogShowAsync()" data-bs-dismiss="offcanvas">Create my cart</div>
  </div>
</ng-template>

<ng-template #user_cartempty>
  <ng-container [ngTemplateOutlet]="shoppingcartinfo"></ng-container>
  <ng-container [ngTemplateOutlet]="cartValidation"></ng-container>
  <div class="h-100 w-100 d-flex flex-column align-items-center justify-content-center">
    <i class="bi bi-cart4"></i>
    <h4 i18n="@@CartPreviewEmptyCartHeadline">Your cart is empty</h4>
    <div class="text-center" i18n="@@CartPreviewEmptyCartMessage">To start shopping,
      add items to your cart.</div>
  </div>
</ng-template>

<ng-template #user_cartfull>
  <ng-container [ngTemplateOutlet]="shoppingcartinfo"></ng-container>
  <ng-container [ngTemplateOutlet]="cartValidation"></ng-container>
  <div #positionListContainer class="position-list-container w-100">

    @if ((cartPreviewItemList | cartItemFilterValid).length > 0) {
      @if (cartValidationResult != undefined) {
        <div class="cart-preview-validation-text valid" i18n="@@CartPreviewValidItems">Valid items</div>
      }
      <div class="position-list">
        @for (cartPreviewValidItem of cartPreviewItemList | cartItemFilterValid; track cartPreviewValidItem) {
          <app-cart-preview-item [cartPreviewItem]="cartPreviewValidItem"
            [shouldDisplayValidation]="shouldDisplayCartItemValidation" class="d-block position">
          </app-cart-preview-item>
        }
      </div>
    }

    @if ((cartPreviewItemList | cartItemFilterInvalid).length > 0 || (cartPreviewItemInactiveList != undefined && cartPreviewItemInactiveList.length > 0)) {
      @if (cartValidationResult != undefined) {
        <div class="cart-preview-validation-text invalid" i18n="@@CartPreviewInvalidItems">Invalid items</div>
      }
      <div class="position-list">
        <!-- invalid items in normal list -->
        @for (cartPreviewInvalidItem of cartPreviewItemList | cartItemFilterInvalid; track cartPreviewInvalidItem) {
          <app-cart-preview-item [cartPreviewItem]="cartPreviewInvalidItem"
            [shouldDisplayValidation]="shouldDisplayCartItemValidation" class="d-block position">
          </app-cart-preview-item>
        }
        <!-- invalid items in inactive list -->
        @for (cartPreviewItemInactiveProductIdentifier of cartPreviewItemInactiveList; track cartPreviewItemInactiveProductIdentifier) {
          <app-cart-preview-item-inactive [productIdentifier]="cartPreviewItemInactiveProductIdentifier"
            class="d-block position">
          </app-cart-preview-item-inactive>
        }
      </div>
    }


  </div>
  <div class="mb-summary-price-total mt-auto p-3 w-100">
    @if (shouldLoadPrices == true) {
      <div class="d-flex">
        <span i18n="@@CartPreviewSummaryPriceTotalNetLabel">Total price net:</span>
        <span class="me-auto"></span>
        <div>
          <app-price-simple [price]="cart?.totalPrice"></app-price-simple>
        </div>
      </div>
      <div class="d-flex">
        <span i18n="@@CartPreviewSummaryDepositTotalLabel">+ deposit:</span>
        <span class="me-auto"></span>
        <div>
          <app-price-simple [price]="cart?.totalDepositPrice" [shouldDisplay0Prices]="true"></app-price-simple>
        </div>
      </div>
    }
  </div>

  <ng-container [ngTemplateOutlet]="cartItemListValidation"></ng-container>
  <ng-container [ngTemplateOutlet]="cartValidityCheckButton"></ng-container>
</ng-template>

<ng-template #cartValidityCheckButton>
  @if (isCartDeliveryDateValid) {
    @if (!isLoading) {
      <button role="link" class="btn btn-primary btn-pretty w-100 cart-validity-check"
        (click)="cartValidityUpdateClickAsync()" [disabled]="cartIsValid == false">
        <i class="mx-2 bi bi-cart4"></i>
        <span i18n="@@CartPreviewCartValidityCheckButton">Check availability</span>
      </button>
    }
  }
  @if (!isCartDeliveryDateValid) {
    @if (!isLoading) {
      <button role="link" class="btn btn-primary btn-pretty w-100 cart-validity-check c-pointer"
        (click)="cartCreationDialogShowAsync(cart, false)" data-bs-dismiss="offcanvas">
        <i class="mx-2 bi bi-calendar-date"></i>
        <span i18n="@@CartPreviewEditCartButtonLabel">Edit delivery date</span>
      </button>
    }
  }
  @if (isLoading) {
    <button role="link" class="btn btn-secondary btn-pretty w-100 cart-validity-check">
      <app-loading-indicator-base [loadingIndicatorStyle]="eLoadingIndicatorStyle"></app-loading-indicator-base>
    </button>
  }
</ng-template>

<ng-template #shoppingcartinfo>
  <app-cart-preview-info [config]="cartPreviewInfoConfig">
    <ng-container [ngTemplateOutlet]="customerinfo"></ng-container>
    <app-address-detail class="d-flex m-2 fs-12px" [address]="cart?.deliveryAddressData" [isHeaderVisible]="false"
      [isEmbeddedInCard]="false">
    </app-address-detail>
  </app-cart-preview-info>
</ng-template>

<ng-template #cartValidation>
  @if (cartValidationResult != undefined) {
    <div class="w-100 cartValidation mx-1">
      <app-cart-validation-result-cart></app-cart-validation-result-cart>
    </div>
  }
</ng-template>

<ng-template #cartItemListValidation>
  @if (cartValidationResult != undefined) {
    @if (cartValidationResult.itemValidationErrorList != undefined && cartValidationResult.itemValidationErrorList.length > 0) {
      <div class="w-100 cartItemListValidation invalid">
        <span i18n="@@CartPreviewCheckoutInvalidItems">Some items in your cart are invalid.</span>
      </div>
    }
  }
</ng-template>
